import { render, staticRenderFns } from "./CompanyAddModule.vue?vue&type=template&id=96782c78&scoped=true&"
import script from "./CompanyAddModule.vue?vue&type=script&lang=js&"
export * from "./CompanyAddModule.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAddModule.vue?vue&type=style&index=0&id=96782c78&prod&scoped=true&lang=scss&"
import style1 from "./CompanyAddModule.vue?vue&type=style&index=1&id=96782c78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96782c78",
  null
  
)

export default component.exports